<template>
  <div>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true">
        <el-form-item style="width:300px">
          <el-input
            v-model="page.criteria"
            @keyup.enter.native="query"
            placeholder="请输入[委托名称]"
            style="width:300px"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="query">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="add()">新增</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <el-table :data="datalist" height="500" style="width: 100%">
      <el-table-column prop="clientName" label="委托方名称" width="180"></el-table-column>
      <el-table-column prop="simpleName" label="样品名称" width="200"></el-table-column>
      <!-- <el-table-column prop="reportType" label="报告版本" width="180"></el-table-column>
      <el-table-column prop="reportForm" label="报告形式" width="130"></el-table-column>
      <el-table-column
            label="样品处理"
            width="120">
            <template slot-scope="scope">{{sampleHandle(scope.row.sampleHandle)}}</template>
      </el-table-column>-->
      <el-table-column prop="basis" label="检验依据" width="180"></el-table-column>
      <el-table-column prop="items" label="检验项目" width="180"></el-table-column>
      <el-table-column label="该检验是否与诉讼有关" width="180">
        <template slot-scope="scope">{{Whether(scope.row.lawsuit)}}</template>
      </el-table-column>
      <el-table-column label="操作" min-width="380">
        <template slot-scope="scope">
          <!-- <el-button size="small" type="success" @click="edit(scope.$index,scope.row)">编辑</el-button>
          <el-button size="small" type="danger" @click="deleteRow(scope.$index, scope.row)">删除</el-button>
          <el-button size="small" type="info" @click="addSatisfaction(scope.$index, scope.row)">满意度</el-button>
          <el-button size="small" type="info" @click="addComplaint(scope.$index, scope.row)">意见或投诉</el-button> -->
          <!-- <el-button size="small" type="info">
            <a href="http://fw.ceprei.com/file/user-photo.png" target="blank">下载报告</a>
          </el-button> -->
          <el-button size="small" type="info" @click="downPort(scope.$index, scope.row)">
            <a :href='href'>下载报告</a>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pull-right clearfix"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="totalsize"
      layout="total, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
    <!--意见或投诉填写表-->
    <el-dialog :title="formtitle" :visible.sync="dialogFormVisibleComplaint">
      <el-form ref="conData" :model="conData" :rules="rules2" label-width="100px">
        <el-form-item label="委托编号" style="display:none;">
          <el-input v-model="conData.consignationId"></el-input>
        </el-form-item>
        <el-form-item style="width:120px!important;" label="满意程度选项"></el-form-item>
        <el-radio-group v-model="conData.checkList" style="width:100px!important;">
          <el-radio v-for="report in checkLists" :label="report" :key="report">{{report}}</el-radio>
        </el-radio-group>
        <el-form-item label="投诉或意见" prop="remark">
          <el-input type="textarea" :rows="4" v-model="conData.remark"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisibleComplaint = false">取 消</el-button>
        <el-button type="primary" @click="addComplaintalert('conData')">确 定</el-button>
      </div>
    </el-dialog>
    <!--满意度填写表-->
    <el-dialog :title="formtitle" :visible.sync="dialogFormVisibleSatisfaction">
      <el-form :rules="rules" :model="conData2" label-width="100px" ref="conData2">
        <el-form-item label="委托编号" style="display:none;">
          <el-input v-model="conData2.consignationId"></el-input>
        </el-form-item>
        <el-form-item label="满意度内容" prop="remark">
          <el-input style="ma" type="textarea" :rows="4" v-model="conData2.remark"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisibleComplaint = false">取 消</el-button>
        <el-button type="primary" @click="addSatisfactionalert('conData2')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>


<script>
import { RequestPost } from "../../api/api";
import { RequestGet } from "../../api/api";
import { url } from "../../api/api";
import { PageSize } from "../../api/api";
import { timeFormat } from "../../api/format";
import { dateFormat } from "../../api/format";
import { state } from "../../api/format";
import { sampleHandle } from "../../api/format";
import { Whether } from "../../api/format";
const checkList = ["非常满意", "比较满意", "一把", "比较不满意", "非常不满意"];
export default {
  methods: {
    dateFormat,
    timeFormat,
    sampleHandle,
    Whether,
    state,
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNumber = val;

      this.page.pageNumber = val;
      /**
       * 1.get 请求传参数，必须是json前面加一个params
       * 2.post传参数不需要在json对象传值前面带params
       */
      this.loadData();
    },
    /**
     * 查询
     */
    query() {
      this.loadData();
    },
    deleteRow(index, rows) {
      this.$confirm("是否确认删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "删除成功!"
          });
          this.dialogFormVisible = false;
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    edit(index, rows) {
      console.log(rows);
      this.dialogFormVisible = true;
      this.form = rows;
    },
    addComplaint(index, rows) {
      this.dialogFormVisibleComplaint = true;
      this.isEdit = true;
      this.formtitle = "满意度调查";
      this.updateDate = true;
      this.conData.consignationId = rows.id;
    },
    addSatisfaction(index, rows) {
      this.dialogFormVisibleSatisfaction = true;
      this.isEdit = true;
      this.formtitle = "投诉与意见";
      this.updateDate = true;
      this.conData2.consignationId = rows.id;
    },
    add() {
      this.$router.push({ path: "/chooseDept" });
    },
    open2() {
      this.$confirm("是否修改该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "修改成功!"
          });
          this.dialogFormVisible = false;
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消修改"
          });
        });
    },
    addComplaintalert(conData) {
      this.$refs[conData].validate(valid => {
        if (valid) {
          //如果通过验证 to do...
          this.$confirm("是否确认添加该满意内容?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
            .then(() => {
              console.log(this.conData);
              RequestPost("/complaint/addComplaint", this.conData)
                .then(response => {
                  if (response.code == "0000") {
                    this.$message({
                      message: "数据信息保存成功！",
                      type: "success"
                    });
                    this.dialogFormVisibleComplaint = false;
                  } else {
                    this.$message({
                      message: "数据信息保存失败！",
                      type: "error"
                    });
                  }
                  this.loadData();
                })
                .catch(error => {
                  //this.$router.push({ path: "/login" });
                });
              this.dialogFormVisibleComplaint = false;
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消删除"
              });
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    addSatisfactionalert(conData2) {
      this.$refs[conData2].validate(valid => {
        if (valid) {
          //如果通过验证 to do...
          this.$confirm("是否确认添加该满意内容?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
            .then(() => {
              console.log(this.conData2);
              RequestPost("/satisfaction/addSatisfaction", this.conData2)
                .then(response => {
                  if (response.code == "0000") {
                    this.$message({
                      message: "数据信息保存成功！",
                      type: "success"
                    });
                    this.dialogFormVisibleSatisfaction = false;
                  } else {
                    this.$message({
                      message: "数据信息保存失败！",
                      type: "error"
                    });
                  }
                  this.loadData();
                })
                .catch(error => {
                  //this.$router.push({ path: "/login" });
                });
              this.dialogFormVisibleSatisfaction = false;
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消删除"
              });
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    formatterColumn(row, column) {
      switch (row.state) {
        case "10":
          return "审核通过";
          break;
        case "20":
          return "待审核";
          break;
        default:
          return "未知";
      }
    },
    loadData() {
      RequestGet("/consignation/findAll", this.page)
        .then(response => {
          if (response.code == "0000") {
            console.log(response.data);
            this.datalist = response.data;
            this.total = response.page.totalCount;
            this.totalsize = response.page.pageSize;
          }
        })
        .catch(error => {
          console.log("error");
          //this.$router.push({ path: '/login' });
        });
    },
    /**下载报告 */
    downPort(index,row){
        this.href=this.href+row.id;
    }
  },
  created: function() {
    this.loadData();
  },
  data() {
    return {
      conData: { checkList: "非常满意" },
      conData2: {
        remark: ""
      },
      // 校验规则
      rules: {
        remark: [
          {
            required: true, //是否必填
            message: "满意内容不能为空", //规则提示
            trigger: "blur" //何事件触发
          }
        ]
      },
      rules2: {
        remark: [
          {
            required: true, //是否必填
            message: "投诉或意见内容不能为空", //规则提示
            trigger: "blur" //何事件触发
          }
        ]
      },
      formtitle: "",
      checkLists: checkList,
      datalist: [],
      listLoading: false,
      formcolWidth: "120px",
      dialogFormVisible: false,
      dialogFormVisibleComplaint: false,
      dialogFormVisibleSatisfaction: false,
      total: 0, //数据的总数量
      totalsize: 0, //总的页数 = 总数量/每页显示的条数
      currentPage: 1,
      href:'http://fw.ceprei.com/service/consignation/download?uuid=',
      page: {
        pageSize: PageSize, //一页显示的条数
        criteria: "",
        userId: sessionStorage.getItem("userId"),
        enterpriseId: sessionStorage.getItem("enterpriseId"),
        type: sessionStorage.getItem("type")
      }
    };
  }
};
</script>


// WEBPACK FOOTER //
// placeOrderTable.vue?1e3d9616